/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cardoptions1Inputs */

const en_cardoptions1 = /** @type {(inputs: Cardoptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Options`)
};

const de_cardoptions1 = /** @type {(inputs: Cardoptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optionen`)
};

/**
* | output |
* | --- |
* | "Options" |
*
* @param {Cardoptions1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cardoptions1 = /** @type {((inputs?: Cardoptions1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cardoptions1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cardoptions1(inputs)
	return de_cardoptions1(inputs)
});
export { cardoptions1 as "cardOptions" }